module.exports = __webpack_public_path__ + "fonts/Gotham-XLight.64043058.otf";